import React, { useState } from 'react';
import { Demanda, devolverDemandaGestorTecnico } from '@app/api/demanda';
import { Button, FormatText, FormTextArea, FormSubmitButton, MasterDetailForm, Row, Widget } from '@digital/ui';
import { Modal, Tooltip } from 'antd';
import * as Yup from 'yup';

interface Props {
  onUpdate: any;
  demanda: Demanda;
}

function ModalDevolverDemandaGestorTecnico(props: Props) {
  const { onUpdate, demanda } = props;
  const [exibirModal, setExibirModal] = useState(false);

  const handleSubmit = (values: any) => {
    if (demanda) {
      devolverDemandaGestorTecnico({ id: demanda.id, justificativa: values.justificativa }).then(data => {
        if (data.valid) {
          setExibirModal(false);
          onUpdate();
        }
      });
    }
  };

  return (
    <>
      <Tooltip title="Devolve a demanda para correção no preenchimento">
        <Button
          type="danger"
          onClick={() => {
            setExibirModal(true);
          }}>
          Devolver
        </Button>
      </Tooltip>
      <Modal
        title="Devolver Demanda"
        width="690px"
        visible={exibirModal}
        onCancel={() => {
          setExibirModal(false);
        }}
        footer={null}>
        <MasterDetailForm
          key="formDevolucao"
          onSubmit={handleSubmit}
          actions={[
            <Button
              type="link"
              onClick={() => {
                setExibirModal(false);
              }}
              key="close">
              Fechar
            </Button>,
            <FormSubmitButton noIcon type="primary" key="save">
              <FormatText id="ui.commons.save" uppercase />
            </FormSubmitButton>,
          ]}>
          <Widget>
            <Row>
              <FormTextArea
                name="justificativa"
                label="Justificativa"
                span={12}
                validateSchema={Yup.string().trim().required('Campo requerido.')}
                rows={4}
              />
            </Row>
          </Widget>
        </MasterDetailForm>
      </Modal>
    </>
  );
}

export default ModalDevolverDemandaGestorTecnico;
